import { Box, Chip } from '@mui/material';

export interface FilterChipOption<T extends string> {
  value: T | 'ALL';
  label: string;
  count: number;
}

export interface FilterChipsProps<T extends string> {
  options: FilterChipOption<T>[];
  value: T | 'ALL';
  onChange: (next: T | 'ALL') => void;
}

function FilterChips<T extends string>({
  options,
  value,
  onChange,
}: FilterChipsProps<T>) {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {options.map((opt) => {
        const isActive = opt.value === value;
        return (
          <Chip
            key={opt.value}
            label={`${opt.label} (${opt.count})`}
            clickable
            onClick={() => onChange(opt.value)}
            variant={isActive ? 'filled' : 'outlined'}
            color={isActive ? 'primary' : 'default'}
          />
        );
      })}
    </Box>
  );
}

export default FilterChips;
